module.exports = __webpack_public_path__ + "img/security-audit-img-1.f4764101.webp";